import {IconProps} from './types';

function Calendar({stroke = 'currentColor', width = 18, height = 18}: IconProps) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
            <rect x="2" y="3" width="12" height="11" rx="1.5" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
            <path d="M2 6.5H14" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
            <path d="M5.5 1.5V4M10.5 1.5V4" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

export default Calendar;
